import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import Landing from "@/pages/Landing";
import CampagnaB2B from "@/pages/CampagnaB2B";
import Dashboard from "@/pages/Dashboard";
import Audit from "@/pages/Audit";
import Report from "@/pages/Report";
import Privacy from "@/pages/Privacy";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminLeadDetail from "@/pages/AdminLeadDetail";
import AdminSettings from "@/pages/AdminSettings";
import AdminPreventivi from "@/pages/AdminPreventivi";

const ProtectedRoute = ({ children }) => {
  const { admin, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Caricamento…</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <div className="grain" />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/risparmio-b2b" element={<CampagnaB2B />} />
            <Route path="/dashboard/:leadId" element={<Dashboard />} />
            <Route path="/audit/:leadId" element={<Audit />} />
            <Route path="/report/:leadId" element={<Report />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/leads/:leadId" element={<ProtectedRoute><AdminLeadDetail /></ProtectedRoute>} />
            <Route path="/admin/preventivi" element={<ProtectedRoute><AdminPreventivi /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
